import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { TechStrategyState } from '../type/query-transform.type';

export const TechStrategyModel = Symbol('TechStrategyModel');

export interface TechStrategyModel extends AbstractModel<TechStrategyState> { }

@injectable()
export class TechStrategyModelImpl extends AbstractModelImpl<TechStrategyState> implements TechStrategyModel {
    protected _modelData: TechStrategyState = {
        queryList: [],
        loading: true,
        saveLoading: false,
    };
}
